import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SidebarModule } from 'ng-sidebar';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockUIModule } from 'ng-block-ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { NgbModule, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './components/header/header.component';
import { DatePipe, DecimalPipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpErrorInterceptorService } from './services/http-error-interceptor.service';
import { RequestInterceptorService } from './services/request-interceptor.service';
import { LegalTemplatesComponent } from './components/legal-templates/legal-templates.component';
import { GenerateTemplateComponent } from './components/generate-template/generate-template.component';
import { CrediserverComponent } from './components/crediserver/crediserver.component';
import { PremissionsComponent } from './components/premissions/premissions.component';
import { UsersComponent } from './components/users/users.component';
import { ViewTemplateDocumentsComponent } from './components/view-template-documents/view-template-documents.component';
import { PersonCardsComponent } from './components/person-cards/person-cards.component';
import { TwoDigitDecimaNumberDirective } from './common/two-digit-decimal-number.directive';
import { NumberToWordsPipe } from './pipes/number-to-words.pipe';
import { DateToWordsPipe } from './pipes/date-to-words.pipe';
import { RolesComponent } from './components/roles/roles.component';
import { AssignmentsComponent } from './components/assignments/assignments.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CrediserverConfigurationComponent } from './components/crediserver-configuration/crediserver-configuration.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    HeaderComponent,
    LegalTemplatesComponent,
    GenerateTemplateComponent,
    CrediserverComponent,
    PremissionsComponent,
    UsersComponent,
    ViewTemplateDocumentsComponent,
    PersonCardsComponent,
    TwoDigitDecimaNumberDirective,
    NumberToWordsPipe,
    DateToWordsPipe,
    RolesComponent,
    AssignmentsComponent,
    CrediserverConfigurationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SidebarModule.forRoot(),
    BlockUIModule.forRoot(),
    AppRoutingModule,
    FontAwesomeModule,
    HttpClientModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    DragDropModule
  ],
  providers: [
    DatePipe,
    DecimalPipe,
    NumberToWordsPipe,
    DateToWordsPipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
